<script setup>
// Get Phuket primary lockup: the sun mark (azure via --sun) + the
// `getphuket` wordmark — Sora in the CRM/portals, Cormorant on the
// marketing surface (see .public-shell .brand-lockup__word in
// application.css). Source SVG: docs/brand/logo/sun.svg.
// Pass :wordmark="false" for the bare sun (avatar / tight contexts).
defineProps({
  wordmark: { type: Boolean, default: true },
})
</script>

<template>
  <span class="brand-lockup">
    <svg class="brand-lockup__sun" viewBox="0 0 120 120" width="28" height="28" aria-hidden="true">
      <g stroke="currentColor" stroke-width="9" stroke-linecap="round">
        <line x1="60" y1="10" x2="60" y2="26" />
        <line x1="60" y1="94" x2="60" y2="110" />
        <line x1="10" y1="60" x2="26" y2="60" />
        <line x1="94" y1="60" x2="110" y2="60" />
        <line x1="25" y1="25" x2="36" y2="36" />
        <line x1="84" y1="84" x2="95" y2="95" />
        <line x1="95" y1="25" x2="84" y2="36" />
        <line x1="36" y1="84" x2="25" y2="95" />
      </g>
      <circle cx="60" cy="60" r="26" fill="currentColor" />
    </svg>
    <span v-if="wordmark" class="brand-lockup__word">getphuket</span>
  </span>
</template>

<style scoped>
.brand-lockup {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.brand-lockup__sun {
  width: 1.75rem;
  height: 1.75rem;
  color: var(--sun, var(--accent));
  flex: none;
}
.brand-lockup__word {
  /* Pinned to Sora via --wordmark on the public surface (the marketing
     headings are a serif since the 2026-09 rebrand); the CRM has no
     --wordmark and falls through to its live display font as before. */
  font-family: var(--wordmark, var(--display));
  font-weight: 800;
  font-size: 1.2rem;
  letter-spacing: -0.025em;
  color: var(--ink);
}
</style>
